'use client';
import React, { useEffect, useState } from 'react';
import AvailabilitySelectionView from './AvailabilitySelectionModule.view';
import {
  AvailabilitySelectionEvents,
  DATES_PER_PAGE,
} from './AvailabilitySelectionModule.machine';
import { ActorRef } from 'xstate';
import { useActor } from '@xstate/react';

const AvailabilitySelectionModule = ({
  track,
  availbility_actor_ref,
}: {
  track: (
    event_name: string,
    meta: Record<string, string | number>
  ) => void;
  availbility_actor_ref: ActorRef<AvailabilitySelectionEvents, any>;
}) => {
  const [state, send] = useActor(availbility_actor_ref);

  const [paginator_state, setState] = useState<
    'paginating' | 'last' | 'start' | 'expanded'
  >('start');

  const isPaginating = () =>
    [
      'thirty_minute_appointments.paging.paginating',
      'sixty_minute_appointments.paging.paginating',
    ].some(state.matches);

  const isStart = () =>
    [
      'thirty_minute_appointments.paging.start',
      'sixty_minute_appointments.paging.start',
    ].some(state.matches);

  const isLast = () =>
    [
      'thirty_minute_appointments.paging.last',
      'sixty_minute_appointments.paging.last',
    ].some(state.matches);

  const isExpanded = () =>
    [
      'thirty_minute_appointments.expanded',
      'sixty_minute_appointments.expanded',
    ].some(state.matches);

  useEffect(() => {
    switch (true) {
      case isPaginating():
        setState('paginating');
        break;
      case isStart():
        setState('start');
        break;
      case isLast():
        setState('last');
        break;
      case isExpanded():
        setState('expanded');
        break;
    }
  }, [state]);

  const toggleDuration = () => {
    track('clicked toggle duration', {});
    send('TOGGLE_DURATION');
  };
  const increment = () => {
    track('paginate availability next', {});
    send('NEXT');
  };
  const decrement = () => {
    track('paginate availability previous', {});
    send('PREVIOUS');
  };
  const selectSlot = (selected: string) => {
    track('selected availability', { selected }); // CRITICAL for analytics
    send({
      type: 'SELECT',
      data: { selected },
    });
  };

  const [pages, setPages] = useState<string[][]>([[]]);

  useEffect(() => {
    if (state.matches('thirty_minute_appointments')) {
      const index = state.context.thirty_minute_page_start_index;
      const pages = state.context.thirty_minute_slots.slice(
        index,
        index + DATES_PER_PAGE
      );
      setPages(pages);
    } else {
      const index = state.context.sixty_minute_page_start_index;
      const pages = state.context.sixty_minute_slots.slice(
        index,
        index + DATES_PER_PAGE
      );
      setPages(pages);
    }
  }, [state.context, state.value]);

  return (
    <AvailabilitySelectionView
      state={paginator_state}
      mentor_info={state.context.mentor_info}
      duration={state.matches('thirty_minute_appointments') ? 30 : 60}
      toggleDuration={toggleDuration}
      pages={pages}
      increment={increment}
      decrement={decrement}
      expanded_index={
        state.matches('thirty_minute_appointments')
          ? state.context.thirty_minute_expanded_index
          : state.context.sixty_minute_expanded_index
      }
      toggleExpand={(index: number) => {
        track(`toggle ${isExpanded() ? 'less' : 'more'} times`, {
          index,
        });
        send({ type: 'TOGGLE_EXPANDED', data: { index } });
      }}
      selectSlot={selectSlot}
    />
  );
};

export default AvailabilitySelectionModule;
